import Vue from 'vue'
import Vuex from 'vuex'
import Profile from './profile'
import Extracts from './shopify-extracts'
import ShopifyStores from './shopify-stores'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  getters: {
  },
  modules: {
    profile: Profile,
    extracts: Extracts,
    shopifyStores: ShopifyStores
  }
})

export default store
